// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

var ReactRailsUJS = require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');

import Routes from 'components/routes';
import WebpackerReact from 'webpacker-react';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import '@shopify/polaris/dist/styles.css';

require("shopify_app")
WebpackerReact.setup({ Routes });

// import ReactDOM from 'react-dom'
// import HelloWorld from '../components/HelloWorld'

// Support component names relative to this directory:
// var componentRequireContext = require.context("components", true)
// require("react_ujs")
// ReactRailsUJS.useContext(componentRequireContext)

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// require("shopify_app")
